export default function Django_Include() {
  return <div>Django_Include Component</div>;
}
